import React, {FC, useEffect, useState} from 'react'
import {Modal} from 'react-bootstrap-v5'
import {useMailTemplateOptions} from '../shared/useMailTemplateOptions'
import {IHrProcessFlowNode} from './HrProcessStepModel'

type Props = {
  node: IHrProcessFlowNode | null
  saving: boolean
  onClose: () => void
  onSubmit: (node: IHrProcessFlowNode, mailTemplateId: string | null) => void
}

/** Adıma mail şablonu bağlar; aday bu adıma geldiğinde şablon ile mail gönderilir. */
export const StepMailTemplateModal: FC<Props> = ({node, saving, onClose, onSubmit}) => {
  const [mailTemplateId, setMailTemplateId] = useState('')
  const {options, loading} = useMailTemplateOptions(!!node, node?.mailTemplateId)

  useEffect(() => {
    setMailTemplateId(node?.mailTemplateId ?? '')
  }, [node])

  return (
    <Modal show={!!node} onHide={onClose} dialogClassName='modal-dialog-centered' backdrop='static'>
      <div className='modal-header'>
        <h5 className='modal-title'>Adım Maili</h5>
        <button type='button' className='btn-close' onClick={onClose} />
      </div>
      <div className='modal-body'>
        <div className='mb-5'>
          <div className='text-muted fs-7'>Adım</div>
          <div className='fw-bolder fs-5'>{node?.name}</div>
        </div>

        <label className='form-label fw-bold'>Mail Şablonu</label>
        <select
          className='form-select'
          disabled={loading || saving}
          value={mailTemplateId}
          onChange={(event) => setMailTemplateId(event.target.value)}
        >
          <option value=''>Mail gönderilmesin</option>
          {options.map((option) => (
            <option key={option.value} value={option.value}>
              {option.label}
            </option>
          ))}
        </select>
        <div className='form-text'>
          {loading
            ? 'Şablonlar yükleniyor...'
            : options.length === 0
            ? 'Henüz mail şablonu yok. Mail Şablonu ekranından oluşturabilirsiniz.'
            : 'Aday bu adıma geldiğinde seçilen şablon ile otomatik mail gönderilir.'}
        </div>
      </div>
      <div className='modal-footer'>
        <button type='button' className='btn btn-light' onClick={onClose}>
          İptal
        </button>
        <button
          type='button'
          className='btn btn-primary'
          disabled={saving || !node}
          onClick={() => node && onSubmit(node, mailTemplateId || null)}
        >
          {saving ? (
            <span className='indicator-progress' style={{display: 'block'}}>
              Lütfen bekleyin...
              <span className='spinner-border spinner-border-sm align-middle ms-2' />
            </span>
          ) : (
            'Kaydet'
          )}
        </button>
      </div>
    </Modal>
  )
}
